// LoginForm.js
import React from "react";
import { InputFieldLogin } from "./InputField";
import PasswordField from "./PasswordField";
import { GoogleLogin } from "@react-oauth/google";

const LoginForm = ({
  email,
  setEmail,
  password,
  loginError,
  setPassword,

  handleLogin,

  setToggleForm,

  isPasswordHidden,
  setHidePassword,
  emailSelectedLogin,
  setEmailSelectedLogin,
  passwordSelectedLogin,
  setPasswordSelectedLogin,
  passwordForgot,
  handleLoginSuccess,
  handleLoginError,
}) => (
  <div className="w-full h-full">
    <div className="mt-20 sm:mt-0 flex flex-col justify-center items-center h-[30rem] sm:h-[35rem]">
      <form
        onSubmit={handleLogin}
        className="p-8 rounded-lg shadow-md w-screen h-screen sm:h-auto sm:max-w-md bg-white"
      >
        <h1 className="text-4xl mb-10 font-bold text-gray-600">Login</h1>

        <InputFieldLogin
          id="email"
          type="text"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          onFocus={() => setEmailSelectedLogin(true)}
          onBlur={() => setEmailSelectedLogin(false)}
          selected={emailSelectedLogin}
          label="Email"
        />
        <PasswordField
          id="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          onFocus={() => setPasswordSelectedLogin(true)}
          onBlur={() => setPasswordSelectedLogin(false)}
          selected={passwordSelectedLogin}
          isPasswordHidden={isPasswordHidden}
          togglePasswordVisibility={() => setHidePassword(!isPasswordHidden)}
          label={"Password"}
        />
        <div className="text-right">
          <button type="button" onClick={passwordForgot}>
            Password dimenticata?
          </button>
        </div>

        {loginError && <p className="text-red-500">{loginError}</p>}
        <button
          type="submit"
          className="mt-5 bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline w-full"
        >
          Login
        </button>
        {/* Google Login Button */}
        <div className="flex items-center justify-center gap-3 bg-white font-medium py-2 px-4 w-full">
          <GoogleLogin
            onSuccess={handleLoginSuccess}
            onError={handleLoginError}
          />
        </div>

        <p className="">
          Non hai un account?{" "}
          <button
            type="button"
            onClick={() => setToggleForm((prevState) => !prevState)}
            className="text-blue-600 hover:underline"
          >
            Registrati
          </button>
        </p>
      </form>
    </div>
  </div>
);

export default LoginForm;
